import type { IH2OTheme } from '../../../../models/components.models';
import { FontSizes } from '../../../../themes/styles';
import type { NavigationElementMoreStyles } from './types';

export const navigationElementMoreStyles = (_theme: IH2OTheme): NavigationElementMoreStyles => ({
  root: {
    marginLeft: 'auto',
    paddingLeft: 8,
    // The row is a flex container whose title already ellipsises. Without these the trailing
    // content is sized by its own text, so a long value (the environment version) pushed the
    // title out of the row and wrapped onto a second line. Shrinking first keeps the title whole.
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    // flex-basis 0 with grow means this takes only the width left over after the element's own
    // title has been laid out at its natural size, so the title never gives up space to it — the
    // trailing value ellipsises instead. A title longer than the row still ellipsises as before.
    flex: '1 1 0%',
    minWidth: 0,
    overflow: 'hidden',
    // TooltipHost renders an inline-block wrapper between this element and its text, which would
    // otherwise size to the text and overflow rather than letting the text ellipsis.
    '.ms-TooltipHost': {
      minWidth: 0,
      overflow: 'hidden',
    },
    transition: 'transform .2s, opacity .2s',
  },
  text: {
    minWidth: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  nestedArrow: {
    fontSize: FontSizes.xxsmall,
    padding: '0 4px',
  },
});
